const DATE  = 'date'
const MARKET = 'close_price_adj'
const NAV = 'nav'
const VOLUME = 'volume_adj'
const G10K_NAV = 'uv10KNAV'
const G10K_MARKET = 'uv10KMP'

const HOLDING_WEIGHT = 'Weight'
const HOLDING_NAME = 'Security Description' // TODO: change?

const PREMDIS_$ = 'BpsDiff'
const PREMDIS_PCT = 'BpsDiffPct'

const SECTOR_HOLDING_NAME = 'securityName'
const SECTOR_HOLDING_WEIGHT = 'weight'
const SECTOR_HOLDING_SECTOR = 'Sector'
const SECTOR_WEIGHT = 'wgtSector'


module.exports = {
  DATE, MARKET, NAV, VOLUME, G10K_NAV, G10K_MARKET,
  PREMDIS_$, PREMDIS_PCT,
  HOLDING_WEIGHT, HOLDING_NAME, 
  SECTOR_HOLDING_NAME, SECTOR_HOLDING_WEIGHT, SECTOR_HOLDING_SECTOR, SECTOR_WEIGHT
}


// WEBPACK FOOTER //
// ./src/constants.js